import type { SessionBootstrapFailedAction } from './actions.types';

export const sessionBootstrapFailed: (error: Error | string) => SessionBootstrapFailedAction = (error) => ({
  type: 'SESSION.BOOTSTRAP_FAILED',
  payload: {
    error,
  },
});
